import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';

type TStateWithPrev<T> = [T, Dispatch<SetStateAction<T>>, T | undefined];

function useStateWithPrevious<T = any>(value:T) {
  const [state, setState] = useState<T>(value);
  const ref = useRef<T | undefined>(undefined);

  useEffect(() => {
    ref.current = state;
  }, [state]);

  const res: TStateWithPrev<T> =  [state, setState, ref.current];
  return res;
}

export default useStateWithPrevious;